import React, { useState } from "react";
import CoAdminPermissionList from "./CoAdminPermissionList.component";
import PermissionApprovedCard from "./PermissionApprovedCard.component";
import SearchIcon from "../../../../../assets/Icons/Universal/Search.svg";
import FilterIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Staffs/FilterIcon.svg";

const ActCoSubAdmin = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleFilterChange = (value) => {
    setSelectedFilters((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  return (
    <div className="flex-col flex-1 w-full h-full radius-10 back-white  align-left  pt-2 pb-2 pl-3 pr-3 g-2">
      <h3 className="t-16 poppins color-black weight-500">
        Here you can add admin as an act admin. They can get all access except
        settings portion.
      </h3>
      <div className="flex-1 w-full flex-col align-left justify-start g-05">
        {/* already given permission list  */}
        <div
          style={{ height: "30%" }}
          className="w-full flex-col align-left justify-start border-2-grayBorder radius-10 scroll-y p-05 pr-1"
        >
          <PermissionApprovedCard
            image={""}
            id={""}
            adminType={""}
            designation={""}
          />
          <PermissionApprovedCard
            image={""}
            id={""}
            adminType={""}
            designation={""}
          />
        </div>
        <div
          style={{ height: "45vh" }}
          className="w-full flex-col align-left justify-start border-2-grayBorder radius-10 scroll-y p-05 pr-1 g-1"
        >
          <div className="flex-col g-05 align-start justify-end">
            <div className="staffsPageHeaderCustomComponent">
              <div className="searchInputContainer">
                <input
                  type="text"
                  className="pageHeaderInput"
                  placeholder="Type for search"
                />
                <button className="searchBtn">
                  <img src={SearchIcon} alt="Search" />
                </button>
              </div>
              <div className="staffsFilterSearchButtonContainer">
                <button onClick={() => setShowFilter(!showFilter)}>
                  <img src={FilterIcon} alt="Filter icon" />
                  <span className="filterText">Filter</span>
                </button>
                {showFilter && (
                  <ul className="filterDropdown">
                    {["Management", "Staffs", "Teachers"].map((role) => (
                      <li key={role}>
                        <input
                          type="checkbox"
                          value={role}
                          checked={selectedFilters.includes(role)}
                          onChange={() => handleFilterChange(role)}
                        />
                        <span>{role}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
          <div className="w-full flex-col align-left justify-start border-2-grayBorder radius-10 scroll-y p-05 pr-1">
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
            <CoAdminPermissionList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActCoSubAdmin;
